import styles from './QuizPdfViewer.module.scss';

/**
 * نوار ابزار مشترک بین حالت‌های PDF.
 * با `hidePagination` گروه صفحه قبل/بعد مخفی می‌شود (مثلاً برای gview).
 */
function PdfToolbar({
    hidePagination = false,
    pct,
    onZoomIn,
    onZoomOut,
    onFitWidth,
    disableZoom,
    pageInput = '',
    pageCountLabel = '…',
    onPageInputChange = () => {},
    onPageInputFocus = undefined,
    onPageInputBlur = () => {},
    onPageInputKeyDown = () => {},
    onGoPrev = () => {},
    onGoNext = () => {},
    disablePrev = true,
    disableNext = true,
    disablePageInput = true,
    onReload,
    openInNewTabUrl,
}) {
    return (
        <div className={styles.toolbar}>
            <div className={styles.toolbarGroup}>
                <button type="button" className={styles.toolBtn} onClick={onZoomOut} disabled={disableZoom} title="کوچک‌نمایی">
                    −
                </button>
                <span className={styles.scaleLabel}>{pct}٪</span>
                <button type="button" className={styles.toolBtn} onClick={onZoomIn} disabled={disableZoom} title="بزرگ‌نمایی">
                    +
                </button>
                <button type="button" className={styles.toolBtnAccent} onClick={onFitWidth} disabled={disableZoom} title="هم‌عرض پنجره / بازنشانی زوم">
                    عرض صفحه
                </button>
                {onReload ? (
                    <button type="button" className={styles.toolBtn} onClick={onReload} title="بارگذاری مجدد PDF">
                        بارگذاری مجدد
                    </button>
                ) : null}
                {openInNewTabUrl ? (
                    <a
                        className={styles.toolBtnLink}
                        href={openInNewTabUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="باز کردن در تب جدید"
                    >
                        تب جدید
                    </a>
                ) : null}
            </div>
            {!hidePagination ? (
                <div className={styles.toolbarGroup}>
                    <button type="button" className={styles.toolBtn} onClick={onGoPrev} disabled={disablePrev}>
                        صفحه قبل
                    </button>
                    <input
                        className={styles.pageInput}
                        aria-label="شماره صفحه"
                        value={pageInput}
                        onChange={onPageInputChange}
                        onFocus={onPageInputFocus}
                        onBlur={onPageInputBlur}
                        onKeyDown={onPageInputKeyDown}
                        disabled={disablePageInput}
                    />
                    <span className={styles.pageMeta}>/ {pageCountLabel}</span>
                    <button type="button" className={styles.toolBtn} onClick={onGoNext} disabled={disableNext}>
                        صفحه بعد
                    </button>
                </div>
            ) : null}
        </div>
    );
}

export default PdfToolbar;
